import './style/index.js';

import _Alert from './Alert';

export type { AlertProps } from './Alert';
export * from './type';

export const Alert = _Alert;
export default Alert;
